import { Component, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyViewsInstanceService } from '../../services/survey-views-instance.service';
import { WINDOW } from '@/window';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-survey-report-now',
  templateUrl: './survey-report-now.component.html',
  styleUrls: ['./survey-report-now.component.scss'],
  standalone: true,
  imports: [CommonModule],
  providers: [SurveyViewsInstanceService]
})
export class SurveyReportNowComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private surveyViewsInstanceService = inject(SurveyViewsInstanceService);
  private window = inject(WINDOW);

  // Signal for loading state
  loading = signal<boolean>(true);

  // Computed property for loading state
  isLoading = computed(() => this.loading());

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams && queryParams.caseId === localStorage.getItem('caseId')) {
      this.surveyViewsInstanceService.accessCenturionV2WithParams(queryParams)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (data) => {
            this.loading.set(false);
            localStorage.removeItem('caseId');
            if (data.jwt) {
              this.window.location.href = `${queryParams.centurionUrl}?census_auth=${data.jwt}`;
            }
          },
          error: (error: any) => {
            this.loading.set(false);
            localStorage.removeItem('caseId');
            this.router.navigate(['/404-not-found']);
          }
        });
    } else {
      this.router.navigate(['/404-not-found']);
    }
  }
}
